import { ReactNode } from "react";
import { SWRConfig } from "swr";
import { fetcher } from "./utils/fetcher.ts";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./auth/authProvider.tsx";

const Providers = (props: { children: ReactNode }) => {
  return (
    <HelmetProvider>
      <AuthProvider>
        <SWRConfig
          value={{
            fetcher,
            errorRetryInterval: 1000,
            errorRetryCount: 3,
          }}
        >
          {props.children}
        </SWRConfig>
      </AuthProvider>
    </HelmetProvider>
  );
};

export default Providers;
